module.exports = __webpack_public_path__ + "img/option2-active.a61e1629.webp";